import axios from 'axios';
import { API } from './api';
import { accessDenied, apiError, apiStart, apiEnd } from './api';
import { setMessage } from './message';

const apiMiddleware = ({ dispatch }) => (next) => (action) => {
  next(action);

  if (action.type !== API) return;

  const {
    url,
    method,
    data,
    formData,// for sending payload that includes a file
    accessToken,
    onSuccess,
    onFailure,
    label,
    headers,
    showLoading
  } = action.payload;

  const dataOrParams = ['GET', 'DELETE'].includes(method) ? 'params' : 'data';

  const token =
    url.indexOf('https://graph.microsoft.com') == 0
      ? localStorage.getItem('graph-access-token')
      : localStorage.getItem('access-token');

  // axios default configs
  axios.defaults.baseURL = process.env.REACT_APP_BASE_URL || '';
  //axios.defaults.headers.common['Content-Type'] = 'application/json';
  axios.defaults.headers.common['Access-Control-Allow-Origin'] = process.env.CLIENT_URL;
  axios.defaults.headers.common['Access-Control-Allow-Credentials'] = 'true';
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

  let fullUrl = url;
  let updatedData = data ? Object.assign({}, data) : null;
  //Replace endpoints variables and remove them from data
  if (data) {
    Object.entries(data).map((entry) => {
      if (fullUrl.includes('{' + entry[0] + '}')) {
        fullUrl = fullUrl.replace('{' + entry[0] + '}', entry[1]);
        delete updatedData[entry[0]];
      }
    });
    // if formData is present (with file), only formData will be sent, 
    // so if there is also data(updatedData), then add it to formData as json string
    if (formData) {
      formData.append("dataString", JSON.stringify(updatedData));
    }
  }

  //always dispatched so the per form save indicator can track the request - showLoading
  //only decides whether the full screen overlay comes up with it
  if (label) {
    dispatch(apiStart(label, showLoading));
  }

  axios
    .request({
      url: fullUrl,
      method,
      headers,
      [dataOrParams]: formData ? formData : updatedData
    })
    .then(({ data }) => {
      if (typeof onSuccess === 'function') dispatch(onSuccess(data));
      else if (typeof onSuccess === 'object' && onSuccess.length > 0)
        onSuccess.forEach((onSuccessFunc) => {
          dispatch(onSuccessFunc(data));
        });
      if (label) dispatch(apiEnd(label));
    })
    .catch((error) => {
      console.log('middleware error', error);
      if (typeof onFailure === 'function') dispatch(onFailure(error));
      else if (typeof onFailure === 'object' && onFailure.length > 0)
        onFailure.forEach((onFailureFunc) => {
          dispatch(onFailureFunc(error));
        });
      else {
        // the api sends business-rule failures as { validationMessage } 
        // and crashes as { errorMessage, stackTrace } - 
        // only validationMessage is written for the user to read
        const body = error?.response?.data;
        if (body?.validationMessage)
          dispatch(setMessage(body.validationMessage, 'error'));
        else {
          if (body?.errorMessage) console.error('api error', body.errorMessage);
          dispatch(setMessage('Something went wrong', 'error'));
        }
      }
      if (error?.response && error?.response?.status === 403) {
        dispatch(accessDenied(window.location.pathname));
      }
      //dispatched last so the failure is what the save indicator ends up seeing
      if (label) dispatch(apiError(error, label));
    });
};

export default apiMiddleware;
